// extracted by mini-css-extract-plugin
export default {"wrap":"SubNavigation_wrap__ioPBr","mobile":"SubNavigation_mobile__Vf9pC","desktop":"SubNavigation_desktop__B+yrt"};